import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { GridOptions } from "ag-grid-community";
import ng from "angular";
import { PlannerProductSearchService } from "../services/plannerProductSearchService";
import { OracleDataService } from "@topline/services/oracleDataService";
import { isTrue } from "@topline/services/boolean";
import { Gen } from "@topline/services/api";

class PlannerProductSearchComponentController {
    public gridOptions: GridOptions;
    public gridApi: $TSFixMe;
    public filterConfig: $TSFixMe;
    public brands: $TSFixMe[] = [];
    public markets: $TSFixMe[] = [];
    public regions: $TSFixMe[] = [];
    public businessUnits: $TSFixMe[] = [];
    public lines: $TSFixMe[] = [];
    public currentPage: number;
    public actionColumnTemplate: string;
    public showPlanner: string;
    public searchMode: $TSFixMe;
    public plannerId: $TSFixMe;
    public budgetVersionUid: $TSFixMe;
    public refresh: $TSFixMe;
    public assignmentSource: string;
    public plannerColumnTranslationKey: string;
    public showApproverColumn: string;
    public watchTimeout: $TSFixMe;
    public plannerColumnTemplate: string;
    public onAddAll: (args: { products: Gen.ProductWithAssignmentsDTO[] }) => void;
    public showAddAllButton: boolean;
    public excludedProductCodes: string[];

    static $inject = [
        "$scope",
        "$timeout",
        PlannerProductSearchService.componentName,
        OracleDataService.componentName,
        angularServicesNames.$translate,
        AgGridService.componentName
    ];

    constructor(
        private $scope: ng.IScope,
        private $timeout: ng.ITimeoutService,
        private plannerProductSearchService: PlannerProductSearchService,
        private oracleDataService: OracleDataService,
        private $translate: ng.translate.ITranslateService,
        private agGridService: AgGridService
    ) {}

    $onInit() {
        if (!this.plannerColumnTranslationKey) {
            this.plannerColumnTranslationKey = "ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.PLANNER";
        }
        if (!this.plannerColumnTemplate) {
            this.plannerColumnTemplate = "{{data.plannerName}}";
        }

        this.$scope.$on("LanguageChanged", () => this.agGridService.refreshGridLanguage(this.gridApi));

        this.initializeGridOptions();
        this.filterConfigSetup();

        this.$scope.$watch(
            () => this.searchMode,
            () => {
                this.filterConfig.filterType = this.searchMode;
                this.reloadProductsDebounce();
            }
        );

        this.$scope.$watch(
            () => this.plannerId,
            () => {
                this.filterConfig.plannerId = this.plannerId;
                this.reloadProductsDebounce();
            }
        );

        this.$scope.$watch(
            () => this.budgetVersionUid,
            () => {
                this.filterConfig.budgetVersionUId = this.budgetVersionUid;
                this.reloadProductsDebounce();
            }
        );

        this.$scope.$watch(
            () => this.assignmentSource,
            () => {
                this.filterConfig.assignmentSource = this.assignmentSource;
                this.reloadProductsDebounce();
            }
        );

        this.$scope.$watchCollection(
            () => this.excludedProductCodes,
            () => {
                this.filterConfig.expectProductCodes = this.excludedProductCodes;
                this.reloadProductsDebounce();
            }
        );

        this.refresh = () => {
            this.reloadProducts();
        };

        this.reloadProductsDebounce();

        if (this.showPlanner == "true") {
            this.$scope.$on("plannerProductAssignmentChanged", () => this.reloadProducts());
            this.$scope.$on("gridDataReady", () => this.goToPage());
        }

        this.loadDictionaryData();
    }

    private initializeGridOptions() {
        this.gridOptions = {
            columnDefs: [
                {
                    field: "productCode",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.ORACLE_INDEX"),
                    tooltipField: "productCode"
                },
                {
                    field: "sku",
                    tooltipField: "sku",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.SKU")
                },
                {
                    field: "brand",
                    tooltipField: "brand",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.PRODUCT")
                },
                {
                    field: "market",
                    tooltipField: "market",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.MARKET")
                },
                {
                    field: "region",
                    tooltipField: "region",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.REGION")
                },
                {
                    field: "businessUnit",
                    tooltipField: "businessUnit",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.BU")
                },
                {
                    field: "line",
                    tooltipField: "line",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.LINE")
                },
                {
                    field: "ownerName",
                    tooltipField: "ownerName",
                    headerValueGetter: () => this.$translate.instant(this.plannerColumnTranslationKey),
                    hide: this.showPlanner != "true",
                    sortable: false
                },
                {
                    field: "approverName",
                    tooltipField: "approverName",
                    headerValueGetter: () => this.$translate.instant("PRODUCT_OWNERS.APPROVER"),
                    hide: this.showApproverColumn != "true",
                    sortable: false
                },
                {
                    field: "businessUnitManagerName",
                    tooltipField: "businessUnitManagerName",
                    headerValueGetter: () => this.$translate.instant("PRODUCT_OWNERS.BUSINESS_UNIT_MANAGER"),
                    sortable: false
                },
                {
                    field: "directorName",
                    tooltipField: "directorName",
                    headerValueGetter: () => this.$translate.instant("PRODUCT_OWNERS.DIRECTOR"),
                    sortable: false
                },
                {
                    headerValueGetter: () => this.$translate.instant("PRODUCT_OWNERS.ACTIVE"),
                    field: "isActive",
                    filter: "agSetColumnFilter",
                    cellRenderer: (params: $TSFixMe) =>
                        params.value != null ? this.$translate.instant(isTrue(params.value) ? "YES" : "NO") : "",
                    filterParams: {
                        cellRenderer: (params: $TSFixMe) =>
                            params.value != null ? this.$translate.instant(isTrue(params.value) ? "YES" : "NO") : ""
                    },
                    sortable: false
                }
            ],
            angularCompileRows: true,
            defaultColDef: {
                sortable: true,
                resizable: true,
                filter: false
            },
            animateRows: true,
            pagination: true,
            paginationPageSize: 10,
            rowModelType: "serverSide",
            rowGroupPanelShow: "never",
            domLayout: "autoHeight",
            suppressMultiSort: true,
            localeTextFunc: this.agGridService.transalteFunc,
            onGridReady: config => {
                this.gridApi = config.api;
                config.api.setServerSideDatasource(
                    this.plannerProductSearchService.createDataSource(this.filterConfig)
                );
                config.api.sizeColumnsToFit();
            },
            onGridSizeChanged: config => config.api.sizeColumnsToFit()
        };

        if (this.actionColumnTemplate) {
            this.gridOptions.columnDefs?.push({
                field: "actions",
                headerValueGetter: () => this.$translate.instant("ACTIONS"),
                cellRenderer: () => this.actionColumnTemplate,
                sortable: false
            });
        }
    }

    private filterConfigSetup() {
        this.filterConfig = {
            includeAssignedPlannerColumn: this.showPlanner == "true",
            includeApproverColumn: this.showApproverColumn == "true",
            budgetVersionUId: this.budgetVersionUid
        };
    }

    public reloadProducts() {
        if (this.gridApi) {
            this.currentPage = this.gridApi.paginationGetCurrentPage();
            this.gridApi.onFilterChanged();
        }
    }

    public addAll() {
        var filters = angular.copy(this.filterConfig);
        filters.pageSize = 1000;
        filters.page = 1;
        this.plannerProductSearchService.searchProducts(filters).then(data =>
            this.onAddAll({
                products: data.items
            })
        );
    }

    public goToPage() {
        if (this.currentPage) {
            const totalPages = this.gridApi.paginationGetTotalPages();
            const lastPage = totalPages - 1;
            if (lastPage >= 0 && this.currentPage > 0) {
                const goToPage = this.currentPage > lastPage ? lastPage : this.currentPage;
                this.gridApi.paginationGoToPage(goToPage);
            }
        }
    }

    public reloadProductsDebounce() {
        if (angular.isDefined(this.watchTimeout)) {
            this.$timeout.cancel(this.watchTimeout);
        }
        this.watchTimeout = this.$timeout(() => {
            this.reloadProducts();
        }, 500);
    }

    public brandNameFilterChange() {
        this.reloadProducts();
    }

    public marketChange() {
        this.oracleDataService.getRegions(this.filterConfig.market).then(data => {
            this.regions = data;
        });
        this.reloadProducts();
    }

    public regionChange() {
        this.oracleDataService.getBusinessUnits(this.filterConfig.region).then(data => {
            this.businessUnits = data;
        });
        this.reloadProducts();
    }

    public businessUnitChange() {
        this.oracleDataService.getLines(this.filterConfig.businessUnit).then(data => {
            this.lines = data;
        });
        this.reloadProducts();
    }

    private loadDictionaryData() {
        this.oracleDataService.getDictionaryData("brand", true).then(data => {
            this.brands = data;
        });

        this.oracleDataService.getDictionaryData("market").then(data => {
            this.markets = data;
        });

        this.oracleDataService.getRegions().then(data => {
            this.regions = data;
        });

        this.oracleDataService.getBusinessUnits().then(data => {
            this.businessUnits = data;
        });

        this.oracleDataService.getLines().then(data => {
            this.lines = data;
        });
    }
}

export class PlannerProductSearchComponent implements ng.IComponentOptions {
    static componentName = "plannerProductSearch";
    bindings = {
        callbackScope: "=",
        actionColumnTemplate: "<",
        showPlanner: "@",
        searchMode: "=",
        plannerId: "<",
        budgetVersionUid: "<",
        refresh: "=",
        assignmentSource: "@",
        plannerColumnTranslationKey: "@",
        showApproverColumn: "@",
        onAddAll: "&",
        showAddAllButton: "@",
        excludedProductCodes: "<"
    };
    controller = PlannerProductSearchComponentController;
    template = require("./plannerProductSearchComponent.html");
}

angular
    .module("topline.components")
    .component(PlannerProductSearchComponent.componentName, new PlannerProductSearchComponent());
